import { getTopWindow } from '@/js/libs/framework/top-window/index.ts';
export const DEFAULT_KEY = 'adnz_debug';
export const isDebug = (key = DEFAULT_KEY) => {
    try {
        const top = getTopWindow();
        try {
            const storageValue = !!top.localStorage.getItem(key);
            if (storageValue) {
                return true;
            }
        }
        catch {
            // it's ok
        }
        const searchValue = new URLSearchParams(top.location.search).get(key);
        return !!searchValue;
    }
    catch {
        return false;
    }
};
